import { Col, Form, Input, message, Row } from "antd";
import React, { useState } from "react";
import s from "./ResetPassword.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "antd/es/form/Form";
import { requestOtpToResetPassword } from "../../redux/carSlice";

const ResetPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const [form] = useForm();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const user = useSelector((state) => state.cars.user)?.email;

  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message ? message : "Новый OTP код отправлен на вашу почту",
    });
  };

  const error = (message) => {
    messageApi.open({
      type: "error",
      content: message ? message : "ОТП код неверный!",
    });
  };

  const requestNewOtp = async (values) => {
    try {
      const res = await dispatch(
        requestOtpToResetPassword({
          email: values.email,
        })
      );
      if (res.payload.message) {
        success(res.payload.message);
        navigate("/setNewPassword");
      } else {
      }
      if (res.type === "user/requestOtpToResetPassword/rejected") {
        error("Такая почта не зарегистрирована");
      }
      console.log("res", res);
    } catch (err) {
      console.log("err", err);
    }
  };

  return (
    <div className={s.login}>
      {contextHolder}
      <h2 className={s.h2}>
        <img src='/cncars_logo.png' className={s.logo} /> Сбросить пароль
      </h2>
      <div className={s.subheader}>
        На вашу почту будет отправлен новый ОТП код
      </div>
      <Form
        className={s.form}
        layout='vertical'
        form={form}
        onFinish={requestNewOtp}
        style={{ width: "500px" }}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name='email'
              label='Введите ваш email'
              rules={[
                {
                  required: true,
                  message: "Введите на ваш email",
                },
                { type: "email", message: "Введите корректный email" },
              ]}
            >
              <input placeholder='Введите вашу почту' className={s.input} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <button className={s.enter_btn} type='htmlSubmit'>
            Отправить новый ОТП
          </button>
        </Row>
        <div className={s.no_account}>
          Нет аккаунта? &nbsp;
          <Link to='/register' className={s.register_btn}>
            Зарегестрироваться
          </Link>
        </div>
      </Form>
    </div>
  );
};

export default ResetPassword;
